export const QUERY__POOLS = 'pools';
